import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är ett stadigvarande serveringstillstånd?";
const SHORT_ANSWER = "Ett stadigvarande tillstånd löper tillsvidare och gäller restaurangens ordinarie drift – till skillnad från ett tillfälligt tillstånd som är begränsat i tid.";

export const Route = createFileRoute("/fraga/vad-ar-stadigvarande-tillstand")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är ett stadigvarande serveringstillstånd" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Stadigvarande tillstånd kräver en mer omfattande prövning av lämplighet, lokal och verksamhet. Det krävs godkänt kunskapsprov med 60 frågor (allmänheten) eller 28 frågor (slutet sällskap). Tillsynsavgift tas ut årligen."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/stadigvarande-vs-tillfalligt-serveringstillstand", label: "Stadigvarande vs tillfälligt – jämförelse" }}
      related={[{"to": "/fraga/vad-ar-tillfalligt-tillstand", "label": "Vad är ett tillfälligt serveringstillstånd?"}, {"to": "/fraga/skillnad-stadigvarande-tillfalligt", "label": "Vad är skillnaden mellan stadigvarande och tillfälligt tillstånd?"}, {"to": "/fraga/far-jag-servera-utan-mat", "label": "Får jag servera alkohol utan att servera mat 2026?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är ett stadigvarande serveringstillstånd?" },
      { name: "description", content: "Ett stadigvarande tillstånd löper tillsvidare och gäller restaurangens ordinarie drift – till skillnad från ett tillfälligt tillstånd som är begränsat i tid." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-stadigvarande-tillstand" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-stadigvarande-tillstand" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-stadigvarande-tillstand",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är ett stadigvarande serveringstillstånd", url: "https://alkoholprovet.se/fraga/vad-ar-stadigvarande-tillstand" },
      ]),
    ],
  }),
});
